import { isPersistedFeatureRolloutEnabled } from '@ms/yammer-data/dist/domains/featureRollouts/selectors';
import { FeatureRollout } from '@ms/yammer-data/dist/state/types';
import { getCurrentRedirectUri } from '@ms/yammer-web-authenticators';
import { insertSplash } from '@ms/yammer-web-support/dist/splash';
import { persistConfig } from 'persistedState';
import { isInvertedTheme } from 'teams/theme';

(async () => {
  const config = require(`./${process.env.YAMMER_ENV}.json`);

  config.telemetry.gitRevision = process.env.GIT_REVISION;
  config.adal.redirectUri = getCurrentRedirectUri(config.adal.validAuthRedirectUris, config.adal.redirectUri);
  config.msal.redirectUri = getCurrentRedirectUri(config.msal.validAuthRedirectUris, config.msal.redirectUri);

  const useUpdatedTeamsTokenConfiguration = await isPersistedFeatureRolloutEnabled(
    persistConfig.key,
    FeatureRollout.UpdatedTeamsTokenConfiguration
  );

  if (useUpdatedTeamsTokenConfiguration) {
    config.adal.resources.yammer = 'api://web.yammer.com/botid-26e27eed-f034-49e4-bbc5-031d3c4dc2c4';
    config.msal.resources.yammer = 'api://web.yammer.com/botid-26e27eed-f034-49e4-bbc5-031d3c4dc2c4/user_impersonation';
  }

  insertSplash({
    target: document.getElementById('root'),
    denylist: /^\/(configure|(configure\/.*))$/g,
    shouldUseTeamsSpinner: true,
    isInverted: isInvertedTheme(),
  });

  window.__yammerconfig__ = config;
})();
